// Plugins
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'what-input';

// Modules
import header from './modules/header';
import scroll from './modules/scroll';
import mailto from './modules/mailto';
import expandable from './modules/expandable';
import accordion from './modules/accordion';
import pamplemousse from './modules/pamplemousse';
import pamplemousseWalk from './modules/pamplemousse-walk';
import pamplemousseSit from './modules/pamplemousse-sit';
import reveal from './modules/reveal';
import modal from './modules/modal';
import scrollAnim from './modules/scroll-anim';
import headline from './modules/headline';
import magnetic from './modules/magnetic';
import push from './modules/push';
import draggable from './modules/draggable';
import slider from './modules/slider';
import mouseImages from './modules/mouse-images';
import mouseMove from './modules/mouse-move';

const scrollTopInitialEls = document.querySelectorAll('[data-scroll-top-initial]');
let prevScrollHeight = document.documentElement.scrollHeight;

// Get viewport units
const calcViewportUnits = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const vw = window.innerWidth * 0.01;
  document.documentElement.style.setProperty('--vw', `${vw}px`);

  const pageHeight = document.querySelector('main').offsetHeight;
  document.documentElement.style.setProperty('--pageH', `${pageHeight}px`);
};

// Get Scrollbar width
const getSBWidth = () => {
  const sb = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--sb', `${sb}px`);
  document.body.style.overflow = '';
};

window.addEventListener('resize', () => {
  getSBWidth();
  calcViewportUnits();

  const scrollDiff = prevScrollHeight - document.documentElement.scrollHeight;
  scrollTopInitialEls.forEach(el => {
    el.initialTop = el.initialTop + scrollDiff;
  });
  prevScrollHeight = document.documentElement.scrollHeight;
});

// A11Y
const initModals = () => {
  const modals = document.querySelectorAll('[data-modal]');

  modals.forEach(modal => {
    const focusTrap = document.querySelector('[data-focus-trap]');
    const focusLoop = document.querySelector('[data-focus-loop]');

    const onTrapFocus = () => {
      focusLoop.focus();
    };

    const observer = new MutationObserver(() => {
      const isOpen =
        modal.getAttribute('aria-expanded') == 'true' ||
        modal.getAttribute('aria-hidden') == 'false';

      if (isOpen && focusTrap && focusLoop) {
        focusTrap.addEventListener('focus', onTrapFocus);
      } else if (!isOpen && focusTrap && focusLoop) {
        focusTrap.removeEventListener('focus', onTrapFocus);
      }
    });

    observer.observe(modal, { attributes: true });
  });
};

const onPageLoad = () => {
  // Modules
  lazySizes.init();
  header();
  scroll();
  mailto();
  expandable();
  accordion();
  pamplemousse();
  pamplemousseWalk();
  pamplemousseSit();
  modal();
  headline();
  magnetic();
  push();
  draggable();
  slider();
  mouseImages();
  mouseMove();

  // Layout
  calcViewportUnits();
  getSBWidth();

  // A11Y
  initModals();
};

document.body.classList.add('js');

if (document.readyState !== 'loading') {
  onPageLoad();
} else {
  document.addEventListener('DOMContentLoaded', onPageLoad, { once: true });
}

window.addEventListener('pageshow', () => {
    requestAnimationFrame(() => {
        window.scrollTo(0, 0, { behavior: 'auto' });
        prevScrollHeight = document.documentElement.scrollHeight;

        requestAnimationFrame(() => {
            reveal();
            scrollAnim();

            scrollTopInitialEls.forEach(el => {
              el.initialTop = el.getBoundingClientRect().top;
            });

            setTimeout(() => {
              document.body.classList.add('is-loaded');
            }, 1000);
        });
    });
});
